/* eslint-disable no-sequences */
/* eslint-disable react/no-array-index-key */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import surToggleOverViewPdp from "@tCentro/Handlers/CENPDPOverViewBlockHandler";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import parse from "html-react-parser";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


interface OfferingModel {
    fields: {
        image: string;
        expertName: string;
        expertExperience: string;
        linkTitle: string;
        linkURL: LinkFieldValue;
        expertTime: string;
        isTopSection: boolean;
        topSectionRichContent: string;
        topSectionExpertImage: String;
        subContent: string;
    };
}

const enum fields {
    title = "title",
    description = "description",
    changeImage = "changeImage",
    startDate = "startDate",
    offerings = "offerings",
    contactNumber = "contactNumber",
    isTopSection = "isTopSection",
    topSectionRichContent = "topSectionRichContent",
    topSectionExpertImage = "topSectionExpertImage",
    subContent = "subContent",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.description]: string;
        [fields.changeImage]: string;
        [fields.startDate]: string;
        [fields.contactNumber]: number;
        [fields.offerings]: OfferingModel[];
        [fields.isTopSection]: boolean;
        [fields.topSectionRichContent]: string;
        [fields.topSectionExpertImage]: string;
        [fields.subContent]: string;
    };
}

export interface LookingExpertPDPStyles {
    container?: InjectableCss;
    titleGridItem?: InjectableCss;
    imageGridItem?: InjectableCss;
    imageAndTitleSection?: InjectableCss;
    titileDescriptionGridItem?: InjectableCss;
    scheduleLinkStyle?: InjectableCss;
    expertTitle?: TypographyPresentationProps;
    expertExperience?: TypographyPresentationProps;
    expertTime?: TypographyPresentationProps;
    image?: LazyImageProps;
    chatButtonWrapper?: InjectableCss;
    numberStyles?: InjectableCss;
    topSectionContainer?: InjectableCss;
    topsectionTitle?: TypographyPresentationProps;
    subheadingTopsection?: TypographyPresentationProps;
    imgWrapper?: InjectableCss;
    subContentStyle?: TypographyPresentationProps;
    topSectionHeadingWrapper?: InjectableCss;
}

export const lookingExpertPDPStyles: LookingExpertPDPStyles = {
    titleGridItem: {
        css: css`
            display: flex;
            flex: 1;
            flex-direction: column;
            /* margin-left: 24px; */
            margin-bottom: 0px;
            color: ${getProp("theme.typography.p.color")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 9px;
                    `,
                    css`
                        margin-bottom: 9px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    titileDescriptionGridItem: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    imageAndTitleSection: {
        css: css`
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            justify-content: start;
            gap: 20px;
        `,
    },
    subContentStyle: {
        css: css`
            color: ${getProp("theme.typography.p.color")};
            font-size: ${TYPOGRAPHY.size.large};
            font-weight: ${TYPOGRAPHY.weight.base};
            line-height: 28px;
        `,
    },
    expertTitle: {
        css: css`
            color: ${getProp("theme.typography.p.color")};
            font-size: ${TYPOGRAPHY.size.largest};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 32px;
            display:inline-flex;
            margin-bottom: 10px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: ${TYPOGRAPHY.size.large};
                            line-height: 24px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )};
        `,
    },
    topsectionTitle: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.large};
            color: ${getProp("theme.typography.p.color")};
            line-height: 16px;
            margin-bottom: 16px;
            display: block;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                           font-size: ${TYPOGRAPHY.size.smaller};
                            margin-bottom: 10px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `
    },
    subheadingTopsection: {
        css: css`
            & p {
                font-size: ${TYPOGRAPHY.size.small};
                color: ${COLORS.background.tag};
                line-height: 16px;
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                           font-size: ${TYPOGRAPHY.size.smallest};
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            }
        `
    },
    expertExperience: {
        css: css`
            font-size: ${TYPOGRAPHY.size.large};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 24px;
            margin-bottom: 12px;
        `,
    },
    expertTime: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.base};
            line-height: 20px;
        `,
    },
    chatButtonWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 8px;
        `,
    },
    scheduleLinkStyle: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 16px;
            border: 2px solid ${COLORS.secondary.base};
            border-radius: 24px;
            padding: 8px 12px;
            height: 32px;
            color: ${COLORS.secondary.base} !important;

            span {
                color: ${COLORS.secondary.base} !important;
            }
        `,
    },
    image: {
        css: css`
            aspect-ratio: 1/1;
            object-fit: contain;
            max-width: 104px;
            max-height: 104px;
            height: auto;

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            max-height: max-content;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    numberStyles: {
        css: css`
            color: ${getColor("text.link")};
            font-family: Poppins;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: 24px;
        `,
    },
    imgWrapper: {
        css: css`
            margin-right: 0px;
        `
    },
    topSectionHeadingWrapper: {
        css: css`
             ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css``,
                        css`
                            flex-direction: column;
                            align-items: start !important;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `
    }
};

const mapStateToProps = (state: ApplicationState & CustomApplicationState, ownProps: OwnProps) => {
    return {
        pageLink: ownProps.fields.offerings.map(card => getLink(state, card.fields.linkURL)),
        isExpanded: state.t_components.overViewPdpBlock?.overViewPdpBlockisExpanded,
    };
};

type Props = OwnProps & HasProduct & ReturnType<typeof mapStateToProps>;

const styles = lookingExpertPDPStyles;
const PDPLookingForExpert: React.FC<Props> = ({ fields, pageLink, isExpanded, product }) => {
    const container = {
        css: css`
            padding: 30px 30px 30px 30px;
            background: ${COLORS.background.grayShade};
            // height: ${isExpanded ? "max-content" : "100%"};
            display: flex;
            align-items: center;
            grid-template-columns: 70% 29%;
            justify-content: space-between;
            flex-direction: row;
            gap:15px;
            @media (min-width: 992px) and (max-width: 1180px) {
                display: grid;
                grid-template-columns: 55% 43%;
            }

            @media (max-width: 991px){
                flex-direction: column;
            }
        `,
    };

    const topSectionContainer = {
        css: css`
            background: #E0DFE0;
            height: 100%;
            padding: 14px;
            display: flex;
            align-items: center;
            gap: 15px;
            border: 4px solid #E0DFE0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: grid;
                            grid-template-columns: 23% 72%;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `
    }
    const [chatLink, setChatLink] = useState<any>();
    const [offerringsUpdate, setOfferingData] = useState<any>();
    useEffect(() => {
        const changeImageDaysNumber = Number(fields.changeImage);
        const selectedStartDate = new Date(fields.startDate);
        const todayDate = new Date();

        if (todayDate >= selectedStartDate) {
            const offeringsArrLen = fields.offerings.length;
            const diffDays =
                Math.floor(
                    (Date.UTC(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate()) -
                        Date.UTC(
                            selectedStartDate.getFullYear(),
                            selectedStartDate.getMonth(),
                            selectedStartDate.getDate(),
                        )) /
                    (1000 * 60 * 60 * 24),
                ) / changeImageDaysNumber;
            const diffDaysRound = Math.ceil(diffDays);

            if (offeringsArrLen > diffDaysRound) {
                setOfferingData(fields.offerings[diffDaysRound]);
                setChatLink(pageLink[diffDaysRound]?.url);
            } else if (offeringsArrLen < diffDaysRound) {
                const expertLengthDiff = diffDaysRound % offeringsArrLen;
                setOfferingData(fields.offerings[expertLengthDiff]), setChatLink(pageLink[expertLengthDiff]?.url);
            } else if (offeringsArrLen === diffDaysRound) {
                setOfferingData(fields.offerings[offeringsArrLen - 1]);
                setChatLink(pageLink[offeringsArrLen - 1]?.url);
            }
        }
    }, [fields]);

    return (
        <>
            {fields.isTopSection && !product.brand?.properties?.configuratorUrl && (
                <StyledWrapper {...topSectionContainer}>
                    <StyledWrapper {...styles.imgWrapper}>
                        <LazyImage {...styles.image} src={fields.topSectionExpertImage} altText={fields.title} />
                    </StyledWrapper>

                    <StyledWrapper {...styles.topSectionHeadingWrapper}>
                        {fields.title && (
                            <Typography  {...styles.topsectionTitle}>
                                {fields.title}
                            </Typography>
                        )}
                        <Typography {...styles.subheadingTopsection}>{parse(transformContentHtml(fields.topSectionRichContent), parserOptions)}</Typography>
                    </StyledWrapper>
                </StyledWrapper>
            )}

            {offerringsUpdate && (
                <StyledWrapper {...container}>
                    <StyledWrapper {...styles.titileDescriptionGridItem}>
                        {fields.title && (
                            <Typography  {...styles.expertTitle}>
                                {fields.title}
                            </Typography>
                        )}
                        {fields.subContent && (
                            <Typography  {...styles.subContentStyle}>
                                {fields.subContent}
                            </Typography>
                        )}
                    </StyledWrapper>

                    <StyledWrapper>
                        <StyledWrapper {...styles.imageAndTitleSection}>
                            <StyledWrapper {...styles.imageGridItem}>
                                <LazyImage {...styles.image} src={offerringsUpdate.fields.image} altText={offerringsUpdate.fields.expertExperience} />
                            </StyledWrapper>
                            <StyledWrapper {...styles.titleGridItem}>
                                <Typography as="p" {...styles.expertExperience}>
                                    {offerringsUpdate.fields.expertExperience}
                                </Typography>
                                <StyledWrapper {...styles.chatButtonWrapper}>
                                    <Typography {...styles.numberStyles}>{fields.contactNumber}</Typography>
                                </StyledWrapper>
                                <Typography as="p" {...styles.expertTime}>
                                    {offerringsUpdate.fields.expertTime}
                                </Typography>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(PDPLookingForExpert)),
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.isTopSection,
                displayName: "Is Design for Top section",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
            },
            {
                name: fields.topSectionRichContent,
                displayName: "Content",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                isVisible: item => item.fields.isTopSection,
                defaultValue: "",
            },
            {
                name: fields.topSectionExpertImage,
                displayName: "Expert Image",
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                isVisible: item => item.fields.isTopSection,
                defaultValue: "",
            },
            {
                name: fields.subContent,
                displayName: "Content Section",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
                isVisible: item => !item.fields.isTopSection,
            },
            {
                name: fields.changeImage,
                displayName: "After how many days image should change",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
                isRequired: true,
                isVisible: item => !item.fields.isTopSection,
            },
            {
                name: fields.startDate,
                displayName: "Start date",
                defaultValue: null,
                editorTemplate: "DateTimeField",
                fieldType: "General",
                isVisible: item => !item.fields.isTopSection,
            },
            {
                name: fields.contactNumber,
                displayName: "Contact Number",
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "General",
                isVisible: item => !item.fields.isTopSection,
            },
            {
                name: fields.offerings,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                defaultValue: [],
                fieldType: "Translatable",
                isVisible: item => !item.fields.isTopSection,
                fieldDefinitions: [
                    {
                        name: "image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },

                    {
                        name: "expertExperience",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "linkURL",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                    },
                    {
                        name: "expertTime",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
